"use client";

import { useWindowSize } from "@huub-web/ui";

import {
  SIDE_CONTENT_MEDIUM_BREAKPOINT,
  SIDE_CONTENT_MEDIUM_WIDTH,
  SIDE_CONTENT_SMALL_WIDTH,
} from "../config/layoutConsts";

export const useSideContentWidth = () => {
  const windowSize = useWindowSize();

  const width =
    !windowSize || windowSize.width <= SIDE_CONTENT_MEDIUM_BREAKPOINT
      ? SIDE_CONTENT_SMALL_WIDTH
      : SIDE_CONTENT_MEDIUM_WIDTH;

  return width;
};
